import "./FixtureStats.css";
import {
  FootballStats,
  CricketStats,
  BasketballStats,
  BadmintonStats,
} from "../Stats";
import { useQuery } from "@apollo/client";
import { FIXTURE } from "../../../api/fixture";
import Spinner from "../../../components/Spinner";
import captureException from "../../../utils/captureException";

export default function FixtureStats({ id }) {
  const { loading, error, data } = useQuery(FIXTURE, { variables: { id } });

  if (error) {
    captureException({
      error,
      info: {
        type: "query",
        component: "FixtureStats",
        query: "FIXTURE",
      },
    });
    console.log(error);
    return <div>Error</div>;
  }

  if (loading || !data) {
    return (
      <div
        style={{
          height: "160px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spinner />
      </div>
    );
  }

  const fixture = data?.fixture;
  const sport = fixture?.event?.sport?.name;

  return (
    <div className="fixture-stats-mobile">
      {sport === "Football" && <FootballStats fixture={fixture} />}

      {(sport === "Cricket" || sport === "Box Cricket") && (
        <CricketStats fixture={fixture} />
      )}

      {sport === "Badminton" && <BadmintonStats fixture={fixture} />}

      {sport?.includes("Basketball") && <BasketballStats fixture={fixture} />}
    </div>
  );
}
